import React from "react";

interface CustomAlertProps {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  show: boolean;
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  title = "แจ้งเตือน",
  message,
  confirmText = "ตกลง",
  cancelText = "ยกเลิก",
  onConfirm,
  onCancel,
  show,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-7500 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm" style={{zIndex: 7500}}>
      <div className="w-80 bg-white rounded-2xl shadow-xl overflow-hidden text-center animate-fadeInUp">
        <div className="px-4 pt-5 pb-2">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <p className="text-sm mt-2 text-gray-600">{message}</p>
        </div>
        <div className="border-t border-gray-200 flex flex-col divide-y divide-gray-200">
          {onCancel && (
            <button
              className="py-3 text-brand font-semibold active:bg-gray-100 transition-colors"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button
            className="py-3 text-brand font-semibold active:bg-gray-100 transition-colors"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;
